"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.handleFetchResponse = handleFetchResponse;
exports.default = {};

/**
 * Fetch APIのレスポンスを処理するハンドラ。
 * responseをjsonオブジェクト化して返します
 * @export
 * @param {Object} response fetchのレスポンスオブジェクト
 * @throws response.okがfalseならエラーとしてレスポンスをスローします
 * @returns responseをjsonオブジェクト化して返す
 */

function handleFetchResponse(response, onMaintenance) {
  var responseText = response.text();
  // 4xx系, 5xx系エラーのときには response.ok==false になる
  if (!response.ok) {
    if (response.status === 503) {
      if (onMaintenance) {
        onMaintenance();
      }
    }

    return responseText.then(function (error) {
      return Promise.reject(_extends({}, JSON.parse(error), {
        // ステータスコードをくっつける
        status: response.status
      }));
    });
  }

  return responseText.then(function (text) {
    var responseJson = !text || text.length === 0 ? {} : JSON.parse(text);
    return Promise.resolve(responseJson);
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/frontend_core/dist/rest/handle-errors.js
// module id = 524
// module chunks = 0